export default {"src":"/_next/static/media/store.f55b8bdb.svg","height":34,"width":80};